// import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import {Router, Route, Switch} from 'react-router-dom'
import {history} from './history'
import {routeConfig} from './route'
import {printRecruitConsoleMessageInPrdEnv} from '@/sc_utils/env-helper'
import {initBaiduStatistics} from '@/sc_utils/statistics'
// import '@/sc_style/rem.js'
import '@/sc_style/reset.scss'

const App = () => (
	<Switch>
		{routeConfig.map((routeProps, index) => <Route {...routeProps} exact key={index}/>)}
	</Switch>
)

ReactDOM.render(
	<Router history={history}>
		<Route component={App}/>
	</Router>,
	document.getElementById('root')
)

initBaiduStatistics()

printRecruitConsoleMessageInPrdEnv()
// HMR热更新，勿删，不影响生产发布
module.hot && module.hot.accept()
